/**
 * Official Vipps brand button.
 * Colors from Vipps brand guidelines: #FF5B24 (primary orange).
 */
export default function VippsButton({ onClick, loading = false, size = "lg", className = "" }) {
  const sizeClass = size === "lg"
    ? "h-12 px-6 text-base"
    : "h-10 px-4 text-sm";

  return (
    <button
      onClick={onClick}
      disabled={loading}
      className={`inline-flex items-center justify-center gap-3 rounded-xl font-semibold text-white
        bg-[#FF5B24] hover:bg-[#e04d1a] active:bg-[#c94419]
        transition-colors disabled:opacity-60 disabled:cursor-not-allowed
        ${sizeClass} ${className}`}
    >
      {loading ? (
        <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
      ) : (
        /* Vipps logo mark (simplified V shape) */
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"
            fill="white"
          />
          <path
            d="M8 8l4 8 4-8"
            stroke="#FF5B24"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {loading ? "Connecting…" : "Continue with Vipps"}
    </button>
  );
}
